export default __webpack_public_path__ + "static/media/banner-desk-encerrado.8c45ec50.png";